import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two top-instructors" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_11 = { class: "fs-12 text-body" }
const _hoisted_12 = { class: "text-end pt-1" }
const _hoisted_13 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\" data-v-f1ea0476><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\" data-v-f1ea0476><h3 class=\"mb-0\" data-v-f1ea0476>Group Lessons</h3><div class=\"dropdown action-opt\" data-v-f1ea0476><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-f1ea0476><i data-feather=\"more-horizontal\" data-v-f1ea0476></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-f1ea0476><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"clock\" data-v-f1ea0476></i> Today </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"pie-chart\" data-v-f1ea0476></i> Last 7 Days </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"rotate-cw\" data-v-f1ea0476></i> Last Month </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"calendar\" data-v-f1ea0476></i> Last 1 Year </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"bar-chart\" data-v-f1ea0476></i> All Time </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"eye\" data-v-f1ea0476></i> View </a></li><li data-v-f1ea0476><a class=\"dropdown-item\" href=\"javascript:;\" data-v-f1ea0476><i data-feather=\"trash\" data-v-f1ea0476></i> Delete </a></li></ul></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 6), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(item.class)
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.group.images, (image) => {
                            return (_openBlock(), _createBlock(_component_RouterLink, {
                              to: "/my-profile",
                              class: "ms-m-20",
                              key: image.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: image.image,
                                  class: "wh-44 rounded-circle border border-2 border-color-white",
                                  alt: "user"
                                }, null, 8, _hoisted_9)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]),
                      _createVNode(_component_RouterLink, {
                        to: "/project-management/project-list",
                        class: "flex-grow-1 ms-2 position-relative top-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.group.title), 1),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(item.group.date), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ], 2),
                  _createElementVNode("td", _hoisted_12, [
                    _createVNode(_component_RouterLink, {
                      to: "/project-management/project-list",
                      class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_PaginationTwo, {
          items: "5",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}